export enum Color {
    CHC_BLUE = 'rgb(18, 25, 101)',
    CHC_LIGHT_GREY = 'rgb(191, 191, 191)',
    CHC_GREY = 'rgb(61, 61, 61)',
    CHC_GREYER = 'rgb(91, 91, 91)',
    CHC_GREYEST = 'rgb(21, 21, 21)',
    WHITE = 'rgb(255, 255, 255)',
    BLACK = 'rgb(0, 0, 0)',
}